import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { AccessTime } from "@mui/icons-material";

const SelectorHora = function ({
    onChange,
    sx,
    horas = Array.from({ length: 24 }, (_, i) => i),
}) {
    const [hora, setHora] = useState(horas[0] ?? 0);

    useEffect(() => {
        if (!horas.includes(hora)) {
            const nuevaHora = horas[0] ?? 0;
            setHora(nuevaHora);
            onChange(nuevaHora);
        }
    }, [hora, horas, onChange]);

    const handleChange = (event) => {
        const newValue = event.target.value;
        setHora(newValue);
        onChange(newValue);
    };

    const formatHora = (h) => {
        return `${h.toString().padStart(2, "0")}:00 UTC`;
    };

    return (
        <Box sx={{ ...sx }}>
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: 600,
                    color: "#424242",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <AccessTime sx={{ fontSize: 18, color: "#1a8a9e" }} />
                Hora (UTC)
            </Typography>

            <FormControl fullWidth>
                <Select
                    value={hora}
                    onChange={handleChange}
                    renderValue={(selected) => (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 32,
                                    height: 32,
                                    borderRadius: 1,
                                    bgcolor: "#1a8a9e",
                                    color: "white",
                                    flexShrink: 0,
                                }}
                            >
                                <AccessTime sx={{ fontSize: 20 }} />
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ fontWeight: 600, color: "#2a8fa6" }}
                            >
                                {formatHora(selected)}
                            </Typography>
                        </Box>
                    )}
                    sx={{
                        bgcolor: "white",
                        borderRadius: 2,
                        height: 56,
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                            borderWidth: 2,
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#80deea",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1a8a9e",
                        },
                        "& .MuiSelect-select": {
                            py: 1.5,
                            display: "flex",
                            alignItems: "center",
                        },
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                borderRadius: 2,
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                mt: 1,
                                maxHeight: 300,
                                "& .MuiMenuItem-root": {
                                    py: 1.25,
                                    px: 2,
                                    "&:hover": {
                                        bgcolor: "#f5f5f5",
                                    },
                                    "&.Mui-selected": {
                                        bgcolor: "#e0f7fa",
                                        fontWeight: 600,
                                        "&:hover": {
                                            bgcolor: "#b2ebf2",
                                        },
                                    },
                                },
                            },
                        },
                    }}
                >
                    {horas.map((h) => (
                        <MenuItem key={h} value={h}>
                            {formatHora(h)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default SelectorHora;
